import Vue from "vue";

const isCategoryEnabled = (categories, categoryName) => {
    var reducer = (res, cat) => cat.name === categoryName ? true : res;
    return categories.reduce(reducer, false);
}

const anyVisiblePromotions = (client) => {
    return client && client.bonus && (client.bonus.deposit || client.bonus.registration || client.bonus.cashback || client.bonus.mailing);
}

const isMenuItemEnabled = (client, itemName) => (
    client
    && client.view
    && client.view.categories
    && client.view.categories.menuItems
    && client.view.categories.menuItems.includes(itemName)
);

const menuLinks = [
    {
        name: 'slots',
        route: { name: 'slots' },
        text: 'menu.slots',
        condition: (client, categories) => isCategoryEnabled(categories, 'slots')
    },
    {
        name: 'video-games',
        route: { name: 'video-games' },
        text: 'menu.video-games',
        condition: (client, categories) => isCategoryEnabled(categories, 'video-games')
    },
    {
        name: 'virtual-sports',
        route: { name: 'virtual-sports' },
        text: 'menu.virtual-sports',
        condition: (client, categories) => isCategoryEnabled(categories, 'virtual-sports')
    },
    {
        name: 'live-casino',
        route: { name: 'live-casino' },
        text: 'menu.live-casino',
        condition: (client, categories) => isCategoryEnabled(categories, 'live-casino')
    },
    {
        name: 'covid',
        route: { name: 'covid' },
        text: 'menu.covid',
        condition: (client, categories) => isCategoryEnabled(categories, 'covid')
    },
    {
        name: 'sport-home',
        route: { name: 'sport-home' },
        text: 'menu.sport-home',
        condition: (client, categories) => isCategoryEnabled(categories, 'sport')
    },
    {
        name: 'sport-prematch',
        route: { name: 'sport-prematch' },
        text: 'menu.sport-prematch',
        condition: (client, categories) => isCategoryEnabled(categories, 'sport')
    },
    {
        name: 'sport-live',
        route: { name: 'sport-live' },
        text: 'menu.sport-live',
        condition: (client, categories) => isCategoryEnabled(categories, 'sport')
    },
    {
        name: 'sport-results',
        route: { name: 'sport-results' },
        text: 'menu.sport-results',
        condition: (client, categories) => isCategoryEnabled(categories, 'sport')
    },
    {
        name: 'sport-lottery',
        route: { name: 'sport-lottery' },
        text: 'menu.sport-lottery',
        condition: (client, categories) => isCategoryEnabled(categories, 'sport')
    },
    {
        name: 'sport-autoexpress',
        route: { name: 'sport-autoexpress' },
        text: 'menu.sport-autoexpress',
        condition: (client, categories) => isCategoryEnabled(categories, 'sport')
    },
    {
        name: 'promotions',
        route: { name: 'promotions' },
        text: 'menu.promotions',
        condition: (client, categories) => anyVisiblePromotions(client)
    },
    {
        name: 'mobile-instruction',
        route: { name: 'mobile-instruction' },
        text: 'menu.mobile-instruction',
        condition: (client, categories) => isMenuItemEnabled(client, 'mobile-instruction')
    },
    {
        name: 'aviatrix',
        route: { name: 'game', params: { provider: "aviatrix", game: "aviatrix" } },
        text: 'menu.aviatrix',
        condition: (client, categories) => isMenuItemEnabled(client, 'aviatrix')
    },
    {
        name: 'softgamings',
        route: { name: 'softgamings' },
        text: 'menu.softgamings',
        condition: (client, categories) => isCategoryEnabled(categories, 'softgamings')
    },
    {
        name: 'virtuals',
        route: { name: 'virtuals' },
        text: 'Virtuals',
        condition: () => true
    },
    {
        name: 'shooting',
        route: { name: 'shooting' },
        text: 'Shooting',
        condition: () => true
    },
    {
        name: 'races',
        route: { name: 'races' },
        text: 'Races',
        condition: () => true
    },
    {
        name: 'fast',
        route: { name: 'fast' },
        text: 'menu.fast',
        condition: () => true
    },
    {
        name: 'crash',
        route: { name: 'crash' },
        text: 'menu.crash',
        condition: () => true
    },
    {
        name: 'poker',
        route: { name: 'poker' },
        text: 'menu.poker',
        condition: () => true
    },
    {
        name: 'tv-games',
        route: { name: 'tv-games' },
        text: 'menu.tv-games',
        condition: () => true
    },{
        name: 'scratch-games',
        route: { name: 'scratch-games' },
        text: 'menu.scratch-games',
        condition: () => true
    },
    {
        name: 'table-games',
        route: { name: 'table-games' },
        text: 'menu.table-games',
        condition: () => true
    },
    {
        name: 'toto',
        route: { name: 'toto' },
        text: 'menu.toto',
        condition: () => true
    }
];

const historyLinks = [
    {
        name: 'slots',
        route: { name: 'history-slots' },
        text: 'components.pages.history.slots.title',
        gameCategory: 'slots'
    },
    {
        name: 'video-games',
        route: { name: 'history-video-games' },
        text: 'components.pages.history.video-games.title',
        gameCategory: 'video-games'
    },
    {
        name: 'virtual-sports',
        route: { name: 'history-virtual-sports' },
        text: 'components.pages.history.races.title',
        gameCategory: 'virtual-sports'
    },
    {
        name: 'sport',
        names: ['sport-home', 'sport-prematch', 'sport-live', 'sport-results', 'sport-lottery', 'sport-autoexpress'],
        route: { name: 'history-sport' },
        text: 'components.pages.history.sport.title',
        gameCategory: 'sport'
    },
    {
        name: 'live-casino',
        route: { name: 'history-live-casino' },
        text: 'components.pages.history.live-casino.title',
        gameCategory: 'live-casino'
    },
    {
        name: 'covid',
        route: { name: 'history-covid' },
        text: 'components.pages.history.covid.title',
        gameCategory: 'covid'
    },
    {
        name: 'softgamings',
        route: { name: 'history-softgamings' },
        text: 'components.pages.history.softgamings.title',
        gameCategory: 'softgamings'
    },
    {
        name: 'toto',
        route: { name: 'history-toto' },
        text: 'components.pages.history.toto.title',
        gameCategory: 'toto'
    },
    // ----
    {
        name: 'virtuals',
        route: { name: 'history-virtuals' },
        text: 'Virtuals',
    },
    {
        name: 'shooting',
        route: { name: 'history-shooting' },
        text: 'Shooting',
    },
    {
        name: 'races',
        route: { name: 'history-races' },
        text: 'Races',
    },
    {
        name: 'fast',
        route: { name: 'history-fast' },
        text: 'components.pages.history.fast.title',
    },
    {
        name: 'crash',
        route: { name: 'history-crash' },
        text: 'components.pages.history.crash.title',
    },
    {
        name: 'poker',
        route: { name: 'history-poker' },
        text: 'components.pages.history.poker.title',
    },
    {
        name: 'tv-games',
        route: { name: 'history-tv-games' },
        text: 'components.pages.history.tv-games.title',
    },
    {
        name: 'scratch-games',
        route: { name: 'history-scratch-games' },
        text: 'components.pages.history.scratch-games.title',
    },
    {
        name: 'table-games',
        route: { name: 'history-table-games' },
        text: 'components.pages.history.table-games.title',
    }
];

export default {
    async getMenuLinks() {
        let links = [];
        await Vue.state.client.ensure();
        await Vue.state.games.ensure();
        let client = Vue.state.client.get();
        let categories = Vue.state.games.get().categories;
        client.view.categories.menuItems.forEach(mi => {
            if (mi.indexOf('gameslist.') === 0) {
                const gamesList = mi.replace('gameslist.', '');
                links.push({
                    name: mi,
                    route: { name: 'games-list', params: { gamesList } },
                    text: 'menu.' + mi,
                    condition: () => true
                });
            } else {
                let item = menuLinks.find(l => l.name == mi);
                if (item && item.condition(client, categories)) {
                    links.push(item);
                }
            }
        });
        return links;
    },
    async getHistoryLinks() {
        let links = [];
        await Vue.state.client.ensure();
        await Vue.state.games.ensure();
        let client = Vue.state.client.get();
        client.view.categories.menuItems.forEach(mi => {
            let item = historyLinks.find(l => l.name == mi || (l.names && l.names.includes(mi)));
            if (!item) return;
            if (links.some(l => l.name === item.name)) return;
            links.push(item);
        });
        return links;
    }
}



// WEBPACK FOOTER //
// ./skins/bulmasite/helpers/menu.helper.js